"use client";
import AssetFrame from "./AssetFrame";
import { useState } from "react";
const steps = [
  [
    "Besoin",
    "Votre application, vos contraintes et les interfaces à conserver.",
  ],
  [
    "Étude",
    "Conception ou expertise de l’existant, puis proposition technique.",
  ],
  ["Fabrication", "Échange sur les travaux et les options avant fabrication."],
  ["Essais", "Travaux en atelier et essais prévus dans le dossier."],
  [
    "Suivi",
    "Documents du projet et identification du vérin pour les échanges futurs.",
  ],
];
export default function Method() {
  const [active, setActive] = useState(0);
  return (
    <div>
      <div
        className="cro-method"
        role="tablist"
        aria-label="Les étapes du projet"
      >
        {steps.map(([title], i) => (
          <button
            key={title}
            role="tab"
            id={`method-${i}`}
            aria-controls="method-panel"
            aria-selected={active === i}
            tabIndex={active === i ? 0 : -1}
            onClick={() => setActive(i)}
            onKeyDown={(e) => {
              let n = active;
              if (e.key === "ArrowRight") n = (active + 1) % steps.length;
              else if (e.key === "ArrowLeft")
                n = (active + steps.length - 1) % steps.length;
              else if (e.key === "Home") n = 0;
              else if (e.key === "End") n = steps.length - 1;
              else return;
              e.preventDefault();
              setActive(n);
              document.getElementById(`method-${n}`)?.focus();
            }}
          >
            <b>0{i + 1}</b>
            <span>
              {title}
              <small>
                {
                  [
                    "Écoute et analyse",
                    "Conception et dimensionnement",
                    "Pièce par pièce",
                    "Contrôles et validation",
                    "Traçabilité du vérin",
                  ][i]
                }
              </small>
            </span>
          </button>
        ))}
      </div>
      <div
        id="method-panel"
        className="cro-method-panel"
        role="tabpanel"
        aria-labelledby={`method-${active}`}
        tabIndex={0}
      >
        <div>
          <p className="cro-eyebrow">{steps[active][0]}</p>
          <h3>
            {
              [
                "Écoute et analyse du besoin",
                "Conception et dimensionnement sur mesure",
                "Fabrication pièce par pièce",
                "Contrôles et validation",
                "Traçabilité par numéro de série",
              ][active]
            }
          </h3>
          <p>{steps[active][1]}</p>
          <h4>Ce que nous faisons</h4>
          <p>
            {
              [
                "Nous réunissons les contraintes de la machine et les interfaces à conserver.",
                "Nous étudions le dimensionnement, les matières et les choix techniques.",
                "Les travaux suivent le dossier d’études validé ; un point d’arrêt peut être prévu après usinage.",
                "Les essais convenus permettent la validation ; vous pouvez participer aux points d’arrêt.",
                "L’identification du vérin relie les interventions et les documents du projet.",
              ][active]
            }
          </p>
          <h4>Ce que vous recevez</h4>
          <p>
            {
              [
                "Une définition partagée du besoin.",
                "Un dossier d’études à valider avant fabrication.",
                "Les pièces fabriquées selon le dossier convenu.",
                "Les résultats des essais et les documents prévus au projet.",
                "Les repères nécessaires aux échanges futurs avec notre équipe.",
              ][active]
            }
          </p>
        </div>
        <AssetFrame assetKey="methode" label="Étude et fabrication SECMHY" />
      </div>
    </div>
  );
}
